<template>
  <div class="Product" >
    <div id="carouselOne" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselOne" data-slide-to="0" class="active"></li>
        <li data-target="#carouselOne" data-slide-to="1"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img class="d-block carouse-img-one" src="../assets/selfPrinting/banner1.png" alt="自助打印解决方案专家">
          <div class="content-detail">
            <h1 class="left">印点点自助打印系统</h1>
            <p class="right" style="margin-top:50px">15000+ 打印网点在使用</p>
            <p class="right ">支持OEM，DIY自己专属的自助打印品牌</p>
            <!-- <el-button class="download-btn" type="primary" icon="el-icon-download" @click="goDownloadFn()">立即下载</el-button> -->
          </div>
        </div>
        <div class="carousel-item">
          <img class="d-block carouse-img-one" src="../assets/selfPrinting/banner2.png" alt="电脑自助打印专区">
          <!-- <el-button class="download-btn" type="primary" icon="el-icon-download" @click="goDownloadFn()"
            style="position: absolute;left: 58%;bottom: 8%;">立即下载</el-button> -->
        </div>

      </div>
    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container">
        <div class="row" style="text-align: center;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck" style="padding: 120px 0 70px;">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                <h2>手机自助打印软件</h2>
                <p class="secd">用户使用微信、QQ扫码发送文件，控制打印机直接打印</p>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                  <p class="secd">不占用电脑、优化成本高峰分流、提高营收操作简便、吸引客户</p>
                </div>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                  <p class="secd" style="margin: 4px 0;">1、扫码发送文件</p>
                  <p class="secd" style="margin: 4px 0;">2、自动计价，微信支付</p>
                  <p class="secd" style="margin: 4px 0;">3、打印完成，领取文件</p>
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                <img class="icon" src="../assets/selfPrinting/advert_1.png" alt="Card image cap" style="transform: translateY(-80px);">
                 <el-button  round plain type="primary" style="transform: translateY(-50px);" @click="openVideo(require('../assets/SelfPrinting/手机自助打印.mp4'))">观看视频</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="container">
        <div class="row" style="text-align: center;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck" style="padding: 120px 0 70px;">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                <img class="icon" src="../assets/selfPrinting/advert_2.png" alt="Card image cap" style="transform: translateY(20px);">
                <el-button  round plain type="primary" style="transform: translateY(60px);" @click="openVideo(require('../assets/SelfPrinting/电脑自助打印.mp4'))">观看视频</el-button>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                <h2>电脑自助打印软件</h2>
                <p class="secd">用户使用电脑自助打印，自动计价，扫码支付打印</p>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                  <p class="secd">自动收银、减少人力 ｜ 先支付后打印、防止损耗 ｜ 数据分析、规范财务</p>
                </div>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                  <p class="secd" style="margin: 4px 0;">1、打开文件，设置参数</p>
                  <p class="secd" style="margin: 4px 0;">2、自动计价，扫码支付</p>
                  <p class="secd" style="margin: 4px 0;">3、打印完成，领取文件</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container">
        <div class="row" style="text-align: center;">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck" style="padding: 120px 0 70px;">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                <h2>远程（预约）自助打印</h2>
                <p class="secd">用户通过公众号或小程序端上传文件，可选择自取或配送</p>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">特点：</p>
                  <p class="secd">全天候24小时接单 ｜ 预先支付，防止损耗 ｜ 集中打印、合理分配人力设备</p>
                </div>
                <div style="margin-top: 20px;">
                  <p style="color: #0073CA;font-size: 24px;font-weight: 500;">流程：</p>
                  <p class="secd" style="margin: 4px 0;">1、在线上传、支付订单</p>
                  <p class="secd" style="margin: 4px 0;">2、商家处理订单</p>
                  <p class="secd" style="margin: 4px 0;">3、到店自取，送货上门</p>
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                <img class="icon" src="../assets/selfPrinting/advert_3.png" alt="Card image cap" style="transform: translateY(20px);">
                <el-button  round plain type="primary" style="transform: translateY(60px);" @click="openVideo(require('../assets/SelfPrinting/远程自助打印.mp4'))">观看视频</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div style="padding: 90px 0;text-align: center;">
        <h2 style="margin-bottom: 24px;">资金清算安全</h2>
        <p style="margin: 4px 0;color: #555;">商家可在后台开通微信商户，独立收款，交易资金不经过平台，</p>
        <p style="margin: 4px 0;color: #555;">由腾讯正规支付机构清算到商家银行卡，保障资金的合法合规。</p>
      </div>
    </div>


    <div style="text-align: center;padding: 100px 0;background-color: #F1F9FF;">
      <div class="container">
        <h2 style="margin-bottom: 30px;">多版本 任您选择</h2>
        <p class="secd" style="margin: 4px 0;">考虑广大打印店主、投放商、运营商不同人群不同场景需要，</p>
        <p class="secd" style="margin: 4px 0;">我们推出三种方案可供选择，真正做到量身定制，契合匹配。</p>
      </div>
      <div class="container" style="margin-top: 80px;">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind ">
                <h4 class="version-tit">门店版<span class="secd" style="font-size: 16px;">（免费）</span></h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_1.png" alt="Card image cap">
                  <p class="card-title tit-h">免费试用自助打印系统</p>
                  <!-- <h4 class="card-title">高校免费</h4> -->
                  <p class="card-text secd" >（0投入，拿来直接营业）</p>
                </div>
              </div>
              <div class="card card-kind">
                <h4 class="version-tit">投放商版<span class="secd" style="font-size: 16px;">（付费）</span></h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_2.png" alt="Card image cap">
                  <p class="card-title tit-h">可增加门店·适合投放·共享自助打印机</p>
                  <!-- <h4 class="card-title">990元/终生</h4> -->
                  <p class="card-text secd">（含多家门店）</p>
                  <!-- <p class="card-text secd">电脑端+公众号+小程序+专属服务器</p> -->
                </div>
              </div>
              <div class="card card-kind">
                <h4 class="version-tit">运营商版</h4>
                <div class="card-body">
                  <img class="version-img" src="../assets/SharePrinting/version_3.png" alt="Card image cap">
                  <p class="card-title tit-h">门店无限开·无限制</p>
                  <!-- <h4 class="card-title">6000/终生</h4> -->
                  <p class="card-text secd">（门店不限）</p>
                  <!-- <p class="card-text secd">电脑端+公众号+小程序+专属服务器</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin: 20px 0;">
      <div v-for="(item, index) in versionList" :key="'versionList' + index">
        <div style="background-color: #F1F9FF;">
          <div class="container" style="text-align: center;padding: 25px 0;">
            <div class="row">
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;font-size: 24px;">
                {{ item.name }}
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                门店版
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                投放商版
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="font-size: 24px;">
                运营商版
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="text-align: center;">
          <div class="row" v-for="(items, index) in item.list" :key="items.label + index" style="line-height: 42px;border-bottom: 1px solid #F5F6F8;">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3" style="text-align: right;">
              {{ items.label }}
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v1 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v1 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v1 }}</span>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v2 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v2 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v2 }}</span>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <img v-if="items.v3 === true" src="../assets/SharePrinting/yes.png">
              <img v-else-if="items.v3 === false" src="../assets/SharePrinting/no.png">
              <span v-else>{{ items.v3 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #F1F9FF;">
      <div class="container">
        <div style="padding: 90px 0;text-align: center;">
          <h2 style="margin-bottom: 24px;">软件下载</h2>
          <p style="margin: 4px 0;color: #555;">自助打印软件</p>
          <div class="center_right2">
            <div v-for="(item,index) of dataList" :key="index" class="item">
              <img :src="item.logoUrl" v-if="item.logoUrl" alt="/">
          <template v-else>
            <img v-if="index == 0" src="@/assets/printing/img4.png" alt="/">
            <img v-else src="@/assets/printing/img3.png" alt="/">
          </template>
              <div class="center_right2_tit">
                <p>{{item.name}}<span>{{item.time|timeFun}}</span></p>
                <p v-if="index==0">微信扫码打印，上传原文件，支付后出纸。</p>
                <p v-else>电脑提交文件，弹出收费框，支付后出纸。</p>
              </div>
              <div class="center_right2_dow">
                <button class="btn btn-primary" @click="downloadFun(item.url,item.saveName)">下载</button>
                <p>（ {{item.version}} ）</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <VideoModal ref="videoModal" />
  </div>

      <!-- 视频弹窗 -->
</template>
  
  <script>
import fileDownload from './comm/download';
import VideoModal from './comm/VideoModal.vue'
export default {
  components: { VideoModal },
  data() {
    return {
      show: false,
      versionList: [
        {
          name: "版本功能比较", list: [
            { label: "电脑自助打印", v1: true, v2: true, v3: true },
            { label: "微信公众号自助打印", v1: true, v2: true, v3: true },
            { label: "微信小程序自助打印", v1: true, v2: true, v3: true },
            { label: "QQ小程序自助打印", v1: true, v2: true, v3: true },
            { label: "远程预约打印", v1: true, v2: true, v3: true },
            { label: "自动计价", v1: true, v2: true, v3: true },
            { label: "营销活动", v1: true, v2: true, v3: true },
            { label: "会员充值", v1: true, v2: true, v3: true },
            { label: "文档打印", v1: true, v2: true, v3: true },
            { label: "照片打印", v1: true, v2: true, v3: true },
            { label: "证件照制作", v1: true, v2: true, v3: true },
            { label: "文件复印", v1: true, v2: true, v3: true },
            { label: "电子发票打印", v1: true, v2: true, v3: true },
            { label: "分账管理", v1: true, v2: true, v3: true },
            { label: "多门店管理", v1: false, v2: true, v3: true },
            { label: "微信公众号管理", v1: false, v2: true, v3: true },
            { label: "品牌logo定制", v1: false, v2: true, v3: true },
            { label: "广告对接", v1: false, v2: true, v3: true },
            { label: "微信支付推荐关注公众号", v1: false, v2: true, v3: true },
          ]
        },
        {
          name: "服务内容", list: [
            { label: "提供教程文档", v1: true, v2: true, v3: true },
            { label: "bug反馈及响应", v1: true, v2: true, v3: true },
            { label: "网站部署对接", v1: false, v2: true, v3: true },
            { label: "公众号部署对接", v1: false, v2: true, v3: true },
            { label: "小程序部署对接", v1: false, v2: true, v3: true },
            { label: "定制开关", v1: false, v2: true, v3: true },
          ]
        },
        {
          name: "服务期限", list: [
            { label: "授权使用权限", v1: "终身", v2: "终身", v3: "终身" },
            { label: "免费更新期限", v1: "终身", v2: "终身", v3: "终身" },
            { label: "产品使用培训", v1: true, v2: true, v3: true },
          ]
        },
      ],
      dataList: [
      {
          "name": "自助打印软件",
          "logoUrl": "https://ydd-common.oss-cn-shenzhen.aliyuncs.com/10204f02757621336ef6000e.png",
          "version": "2.3.1.20837",
          "time": "2023-09-08 21:15:33",
          "saveName": "自助打印软件_4_2.3.1.20837.exe",
          "url": "https://ydd-common.oss-cn-shenzhen.aliyuncs.com/%E8%87%AA%E5%8A%A9%E6%89%93%E5%8D%B0%E8%BD%AF%E4%BB%B6_1_2.3.1.20838.exe"
        },
        {
          "name": "电脑自助软件",
          "logoUrl": "https://ydd-common.oss-cn-shenzhen.aliyuncs.com/20240103155912.png",
          "version": "2.1.22147",
          "time": "2024-08-15 19:58:01",
          "saveName": "电脑自助软件_4_2.1.22147.exe",
          "url": "https://ydd-common.oss-cn-shenzhen.aliyuncs.com/%E8%87%AA%E5%8A%A9%E6%89%93%E5%8D%B0%E8%BD%AF%E4%BB%B6_1_2.1.22147.exe"
        }
      ],
      downloadLoading: false
    }
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
      $("#carouselOne").carousel({
        interval: 4000
      });
      $("#carouselTwo").carousel({
        interval: 4000
      });
    }, 200);
  },
  methods: {
    openVideo(src) {
      if (this.$refs.videoModal && this.$refs.videoModal.open) {
        this.$refs.videoModal.open(src)
      }
    },
    goDownloadFn() {
      this.$router.push("/DownLoad")
    },
    downloadFun(url, filename = "") {
      fileDownload({
        filename, url,
        setLoading: (flag) => {
          if (flag) {
            this.downloadLoading = this.$loading({
              lock: true,
              text: '下载中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          } else {
            this.downloadLoading.close();
          }
        }
      });
    },
  },
  filters:{
        timeFun(val){
            var time = new Date(val);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            return y+"-"+m+"-"+d
        }
    }
};
  </script>
  
  <style lang="less" scoped>
/* Chrome, Safari, Opera */
.content {
  width: 100%;
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  padding-top: 61px;
  height: 540px;
  overflow: hidden;
}

.content-detail {
  position: absolute;
  top: 8rem;
  left: 15vw;

  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }

  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.carouse-img-one {
  width: 100%;
}

.active {
  opacity: 1 !important;
}

.content-title {
  text-align: center;
  padding: 60px 0 70px;

  h1 {
    color: #18182a;
    font-weight: normal;
    font-stretch: normal;
    font-size: 40px;
  }
}

.card-kind {
  border: 0px;
  background-color: inherit;

  .version-tit {
    padding-bottom: 50px;
    position: relative;

    &::after {
      content: "";
      width: 64px;
      height: 3px;
      background-color: #00cd95;
      position: absolute;
      border-radius: 99px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .card-body {
    background-color: #fff;
    padding: 50px 0;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1, 1.1);
    }

    .version-img {
      width: 120px;
      height: 120px;
      box-shadow: 8px 14px 25px 1px rgba(0, 255, 185, 0.2);
      margin-bottom: 20px;
    }

    .tit-h {
      color: #00cd95;
      font-weight: 500;
    }
  }

  &:nth-child(2) {
    .version-tit::after {
      background-color: #ff725e;
    }

    .tit-h {
      color: #ff725e;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(255, 114, 94, 0.2);
    }
  }

  &:nth-child(3) {
    .version-tit::after {
      background-color: #00cbf1;
    }

    .tit-h {
      color: #00cbf1;
    }

    .version-img {
      box-shadow: 8px 14px 25px 1px rgba(0, 203, 241, 0.2);
    }
  }
}

.list-item {
  text-align: left;

  h2 {
    font-size: 40px;
    line-height: 28px;
    color: #18182a;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 28px;
    color: #555;
  }
}

.content-detail {
  position: absolute;
  top: 8rem;
  left: 15vw;

  h1 {
    font-size: 2.8rem;
    line-height: 2rem;
    color: #fff;
  }

  p {
    font-size: 1.75rem;
    color: #fff;
  }
}

.center_right2 {
  padding: 44px 0;
  display: flex;
  gap: 40px;
  .item {
    width: 100%;
    min-height: 180px;
    background: #ffffff;
    box-shadow: 0px 1px 44px 2px rgba(38, 38, 38, 0.06);
    border-radius: 8px;
    padding: 20px 36px;
    display: flex;
    align-items: center;
    img {
      width: 65px;
      height: 68px;
      margin-right: 19px;
    }
    .center_right2_tit {
      flex: 1;
      text-align: left;
    }
    .center_right2_tit P:nth-of-type(1) {
      font-size: 20px;
      font-weight: 700;
    }
    .center_right2_tit P:nth-of-type(1) span {
      opacity: 0.6;
      font-size: 16px;
      font-weight: 400;
      margin-left: 17px;
    }
    .center_right2_tit P:nth-of-type(2) {
      font-size: 16px;
      opacity: 0.6;
    }
    .center_right2_dow button {
      width: 140px;
      height: 44px;
      background: rgba(27, 138, 249, 1);
      border-radius: 22px;
      margin-bottom: 13px;
    }
    .center_right2_dow p {
      font-size: 16px;
      color: rgba(24, 24, 42, 1);
      opacity: 0.3;
      width: 140px;
      text-align: center;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/SelfPrinting.vue